import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Controller, RegisterOptions, useFormContext } from "react-hook-form";

interface MUploadFileProps {
  acceptFile: string;
  name: string;
  preloadNameFile?: string;
  validation?: RegisterOptions;
  onFileChange: (file: string | ArrayBuffer | null | undefined) => void;
  downloadFile?: () => void;
  disabled?: boolean;
}

const MUploadFile = ({
  acceptFile,
  name,
  validation,
  preloadNameFile,
  onFileChange,
  downloadFile,
  disabled = false,
}: MUploadFileProps) => {
  const { control } = useFormContext();
  const [fileName, setFileName] = useState<string | null>(
    preloadNameFile || null
  );

  return (
    <Box
      textAlign="center"
      p={2}
      border={1}
      borderRadius={2}
      borderColor="grey.300"
      bgcolor="grey.100"
    >
      <Controller
        name={name}
        control={control}
        rules={validation}
        disabled={disabled}
        render={({ field: { onChange }, fieldState }) => (
          <>
            <input
              key={name}
              accept={acceptFile}
              style={{ display: "none" }}
              id={name}
              type="file"
              disabled={disabled}
              onChange={(event) => {
                const file = event.target.files?.[0] || null;
                if (
                  file &&
                  (file.name.endsWith(acceptFile) ||
                    file.name.endsWith(acceptFile.toUpperCase()))
                ) {
                  setFileName(file.name);
                  onChange(file);
                  const reader = new FileReader();
                  reader.onload = (e) => {
                    onFileChange(e?.target?.result);
                  };
                  reader.readAsText(file, "ISO-8859-1");
                }
              }}
            />
            <label htmlFor={name}>
              <Button
                variant="contained"
                component="span"
                disabled={disabled}
                startIcon={<CloudUploadIcon />}
              >
                Subir archivo
              </Button>
            </label>
            {fileName && (
              <Typography mt={2}>
                Archivo seleccionado:
                {fileName}
                {downloadFile && (
                  <Button variant="text" color="primary" onClick={downloadFile}>
                    Descargar
                  </Button>
                )}
              </Typography>
            )}
            {fieldState.error && (
              <Typography mt={2} color="red">
                {fieldState.error.message}
              </Typography>
            )}
          </>
        )}
      />
    </Box>
  );
};

export default MUploadFile;
